import { Component, OnInit } from '@angular/core';
import { FinanceService } from 'src/modules/features/contractor/services';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: [ './dashboard.component.scss' ]
})
export class DashboardComponent implements OnInit {
	collapsePaymentStatus: boolean = true;
	collapseReceiptStatus: boolean = true;
	collapseOldReceiptStatus: boolean = true;
	paymentIRR;
	receiptField = new FormControl('', Validators.required);
	oldReceiptField = new FormControl('', Validators.required);
	paymentField = new FormControl('', Validators.required);
	pending: boolean;
	error: any;
	errorMsg: any;
	success: any;
	arrangements;
	constructor(private financeSvc: FinanceService, private router: Router) {}

	ngOnInit(): void {
		// this.submit();
		// this.download();
		this.getArrangement();
	}

	getArrangement() {
		this.pending = true;
		this.financeSvc.getArrangement({ params: {} }).subscribe(
			(res: any) => {
				this.pending = false;
				this.arrangements = res;
			},
			(error) => {
				this.pending = false;
				this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
			}
		);
	}
	findService(arr, id) {
		for (let i = 0; i < arr.length; i++) {
			let service = arr[i];
			if (service.revenueService.revenueServiceId == id) {
				return service.revenueService.categoryName;
			}
			if (service.children) {
				this.findService(service.children, id);
			}
		}
	}
	goToPayment(payment) {
		this.router.navigate([ '/home-page/pay/instruction' ], {
			queryParams: {
				purpose: this.findService(this.arrangements, payment.payment.paymentDetails.revenue_service_id),
				beneficiary: 'Nigerian Communications Commision',
				amount: payment['amount'],
				rrr: payment.payment['transactionRef'],
				paymentLink: payment['paymentUrl'],
				address: payment['payment']['paymentDetails']['payers_address'],
				description:
					payment['payment']['paymentDetails']['description'] === null
					? payment['payment']['paymentDetails']['invoice_description']
					: payment['payment']['paymentDetails']['description'],
				companyName: payment['payment']['paymentDetails']['company_name'],
				currencyCode: payment['currencyCode'],
				docPath: payment['payment']['detailsDocumentPath'],
				name: payment['payment']['paymentDetails']['payers_name'],
				phone: payment['payment']['paymentDetails']['payers_phone'],
				email: payment['payment']['paymentDetails']['payers_email'],
				paymentType: payment['payment']['paymentDetails']['currencyId'] == 'naira' ? 'LOCAL' : 'FOREIGN'
			}
		});
	}

	submitReceipt() {
		if (this.receiptField.valid) {
			this.pending = true;
			this.financeSvc.getPaymentReceipt({ id: this.receiptField.value }).subscribe(
				(res) => {
					this.pending = false;
					let url = `${environment.API_SERVER}/finance/public/media/?media=${res['documentPath']}`;
					window.open(url, '_blank');
				},
				(error) => {
					this.pending = false;
					this.errorMsg =
						error.status == 404
							? 'Receipts not yet available, check your payment status instead'
							: 'Invalid reference number, please check and try again';
					// this.error = error.message ? error.message : error;
				}
			);
		} else {
		}
	}


	submitOldReceipt() {
		if (this.oldReceiptField.valid) {
					let url = `https://eservices.ncc.gov.ng/old-api-server/adhoc_payment/receipt/?rrr=${this.oldReceiptField.value}&view=false`;
					window.open(url, '_blank');
				}
		}

	submit() {
		if (this.paymentField.valid) {
			this.pending = true;
			this.financeSvc.getPaymentStatus({ id: this.paymentField.value }).subscribe(
				(res) => {
					this.pending = false;
					this.paymentIRR = res;
					console.log('irr', res);
				},
				(error) => {
					this.pending = false;
					this.error =
						error.status == 403
							? 'Invalid reference number, please check and try again'
							: (this.error = error.message ? error.message : error);
					// ;
				}
			);
		} else {
		}
	}

	download() {
		if (this.paymentField.valid) {
			this.pending = true;
			this.financeSvc.getPaymentReceipt({ id: this.paymentField.value }).subscribe(
				(res) => {
					this.pending = false;
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
		} else {
		}
	}
}
